import { render } from "./PaymentAlert.vue?vue&type=template&id=73af873f"
import script from "./PaymentAlert.vue?vue&type=script&lang=js"
export * from "./PaymentAlert.vue?vue&type=script&lang=js"

import "./PaymentAlert.vue?vue&type=style&index=0&id=73af873f&lang=stylus"

import exportComponent from "C:\\projects\\_personal\\poland-shop\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__